import HeroSection from "@/components/home/HeroSection";
import FeaturedDishes from "@/components/home/FeaturedDishes";
import { Card } from "@/components/ui/card";
import { Clock, Shield, Truck, Star } from 'lucide-react';

const Home = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      comment: "The food quality is consistently excellent. My go-to for weekly meals!",
      rating: 5
    },
    {
      name: "Mike Chen",
      comment: "Fresh ingredients and amazing flavors. Highly recommended!",
      rating: 5
    },
    {
      name: "Emily Davis",
      comment: "Great variety and prompt delivery. Perfect for busy professionals.",
      rating: 5
    }
  ];

  return (
    <div className="animate-fade-up">
      <HeroSection />
      <FeaturedDishes />
      
      {/* Features Section */}
      <div className="py-20 bg-[#ea384c]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Choose ReyanSH Kitchen?
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              We combine quality ingredients, expert chefs, and efficient delivery
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Clock,
                title: "Quick Delivery",
                description: "Your favorite meals delivered hot and fresh within 30 minutes"
              },
              {
                icon: Shield,
                title: "Quality Assured",
                description: "Prepared in our hygienic, state-of-the-art kitchen facilities"
              },
              {
                icon: Truck,
                title: "Wide Coverage",
                description: "Serving all major areas in the city with our efficient delivery network"
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="p-6 bg-white rounded-lg hover:shadow-lg transition-shadow"
              >
                <feature.icon className="h-12 w-12 text-[#ea384c] mb-4" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="py-20 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              What Our Customers Say
            </h2>
            <p className="text-lg text-gray-300">
              Don't just take our word for it
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="p-6 bg-[#ea384c] border-none">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-white/90 mb-4">"{testimonial.comment}"</p>
                <p className="font-semibold">{testimonial.name}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;